import { registerComponent, formatMoney } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "pricing-summary",
  class PricingSummary extends WYATTElement {
    constructor() {
      super();

      this.quantityEl = this.querySelector('[data-ref="quantity"]');
      this.unitPriceEl = this.querySelector('[data-ref="unit-price"]');
      this.productCostEl = this.querySelector('[data-ref="product-cost"]');
      this.personalizationRowEl = this.querySelector(
        '[data-ref="personalization-row"]',
      );
      this.personalizationChargeEl = this.querySelector(
        '[data-ref="personalization-charge"]',
      );
      this.estimatedTotalEl = this.querySelector(
        '[data-ref="estimated-total"]',
      );

      this.unitPrice = Number(this.config.unitPrice);

      this.priceBreaks = (this.config.priceBreaks || [])
        .map(({ quantity, price }) => ({
          quantity: Number(quantity),
          price: Number(price),
        }))
        .sort((a, b) => a.quantity - b.quantity);

      this.setupCharge = Number(this.config.setupCharge) || 0;

      this.personalizationUnitPrice =
        Number(this.config.personalizationUnitPrice) || 0;

      this.personalizationEnabled = false;

      this.moneyFormat = this.config.useCurrency
        ? WYATT.shopify.moneyWithCurrencyFormat
        : WYATT.shopify.moneyFormat;

      this.formId = this.config.formId;

      this.quantity = this.getInitialQuantity();

      this.subscribe(
        WYATT.PubSub.events.updateQuantity,
        this.handleQuantityUpdate.bind(this),
      );

      this.subscribe(
        WYATT.PubSub.events.updatePersonalization,
        this.handlePersonalizationUpdate.bind(this),
      );
      this.subscribe(WYATT.PubSub.events.updateOption, this.update.bind(this));

      this.update();
    }

    getInitialQuantity() {
      const quantityInput = document.querySelector(
        `[name="quantity"][form="${this.formId}"]`,
      );

      return Number(quantityInput?.value || 1);
    }

    handleQuantityUpdate(event) {
      const { formId, quantity } = event.detail;

      if (formId !== this.formId) return;

      this.quantity = Number(quantity);
      this.update();
    }

    handlePersonalizationUpdate(event) {
      this.personalizationEnabled = Boolean(event.detail?.enabled) || false;
      this.update();
    }

    getUnitPriceForQuantity(quantity) {
      if (!this.priceBreaks.length) {
        return this.unitPrice;
      }

      return this.priceBreaks.reduce(
        (price, priceBreak) =>
          quantity >= priceBreak.quantity ? priceBreak.price : price,
        this.priceBreaks[0].price,
      );
    }

    update() {
      const unitPrice = this.getUnitPriceForQuantity(this.quantity);
      const productCost = unitPrice * this.quantity;
      const personalizationCost = this.personalizationEnabled
        ? this.personalizationUnitPrice * this.quantity
        : 0;
      const estimatedTotal =
        productCost + this.setupCharge + personalizationCost;

      this.quantityEl.textContent = this.quantity;
      if (this.unitPriceEl) {
        this.unitPriceEl.textContent = formatMoney(unitPrice, this.moneyFormat);
      }

      this.productCostEl.textContent = formatMoney(
        productCost,
        this.moneyFormat,
      );

      if (this.personalizationRowEl) {
        this.personalizationRowEl.hidden = !this.personalizationEnabled;
      }
      if (this.personalizationChargeEl) {
        this.personalizationChargeEl.textContent = formatMoney(
          personalizationCost,
          this.moneyFormat,
        );
      }

      if (this.estimatedTotalEl) {
        this.estimatedTotalEl.textContent = formatMoney(
          estimatedTotal,
          this.moneyFormat,
        );
      }
    }
  },
);
